<div class="col-12 mt-2">
  <p-confirmDialog></p-confirmDialog>
  <div class="col-12 border border-info rounded " #topDiv>
    <div class="col-12 flex">
    <div class="col-1 float-left">
      <button pButton icon="fa fa-refresh" label="Refresh" class="buttonsRound noHover shadow-sm p-2 w-full h-2rem border-round" [disabled]="disableSearch()"
      (click)="refreshTableData()"></button>
    </div>
    <div class="col-3 flex" id="datePicker" style="padding-left: 2%;">
      <div class="ui-inputgroup flex col-2 w-6 p-0 pr-4 h-2rem">
        <button pButton class="theme-button labelButton buttonColor w-9 p-1 border-round-left" type="button" label="From"></button>
        <p-calendar class="datePicker1" [(ngModel)]="fromDate" [maxDate]="toDate ? toDate:maxDate" [dateFormat]="dateFormat"  [style]="{'min-width':'133%'}" [inputStyle]="{'width':'70%','height':'0%'}"></p-calendar>
      </div>
      <div class="ui-inputgroup flex col-2 w-5 p-0 ml-8 h-2rem" style="width: 41%;margin: 0px 17px;">
        <button pButton class="theme-button labelButton buttonColor w-6 p-1" type="button" label="To"></button>
        <p-calendar class="datePicker2" [minDate]="fromDate" [maxDate]="maxDate" [(ngModel)]="toDate" [dateFormat]="dateFormat"  [style]="{'min-width':'155%'}" [inputStyle]="{'width':'70%','height':'0%'}"></p-calendar>
      </div>
    </div>
    <div class=" col-1 ui-inputgroup userIdLable" style="margin-left: 10%;">
      <button pButton icon="fa fa-search" label="Search" class="buttonsRound noHover shadow border-round-left p-2 w-full h-2rem border-round" (click)="onApplyFilter()" style="width: 150px;"
          [disabled]="disableSearch()"></button>
    </div>
  </div>
</div>

<div class="col-12"   [style.height.px]="divHeight">
  <p-table [value]="libprepworkfiles" [columns]="scrollableCols" [loading]="loading" [style]="{'overflow':'visible', 'word-wrap': 'break-word'}"  [scrollHeight]="scrollHeight"
   [scrollable]="true" sortField="fileName" [sortOrder]="-1" [customSort]='true'>
    <ng-template pTemplate="caption">
      <table style="width:100%;"  aria-describedby="table to format">
        <thead>
          <th class="border-none">
            <label style="font-size: large;">Displayed Workfiles (Total Workfiles) : {{getRowsCount()}} ({{getTotalRowCount()}})</label>
          </th>
          <th class="flex justify-content-end border-none">
            <em class="fa fa-search m-1" ></em>
            <input type="text" class="p-1" pInputText size="40" placeholder="Global Filter" [(ngModel)]="tableFilterValue" (input)="filterGlobal($event.target.value)">
          </th>
        </thead>
      </table>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr >
        <ng-container *ngFor="let col of columns">
        <th scope="col" *ngIf="col.field == 'fileName'" class="text-center" style="width: 17rem;" [pSortableColumn]="col.field" (click)="sortColumnheader(sortOrderflag,col.field)">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
        <th scope="col" *ngIf="col.field != 'fileName'" class="text-center" style="width: 10rem;" [pSortableColumn]="col.field" (click)="sortColumnheader(sortOrderflag,col.field)">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" >
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field == 'fileName'" style="width: 17rem;"class="text-center">
            <a href="javascript:void(0);" (click)="downloadFilesFromAzure(rowData[col.field])"><u>{{rowData[col.field]}}</u></a>
          </td>
          <td *ngIf="col.field != 'fileName'"  style="width: 10rem;" class="text-center"> {{getTableRowdata(rowData,col.field)}}</td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr >
        <td [attr.colspan]="8" class="text-center">
          No records found
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <table aria-describedby="table to format">
       <thead>
         <th class="border-none">
           <button pButton class="h-2rem" label="More" icon="pi pi-arrow-down" [disabled]="isMoreButtonDisabled()" (click)="moreToshow()"></button>
         </th>
       </thead>
     </table>
   </ng-template>
  </p-table>
</div>
</div>
<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
